import { compose, map, sortBy } from 'lodash/fp';
import { Device } from '@mews-commander/legacy-data-structures';
import { PRINTERS_FETCH } from '../actions/constants';
import { reducersFactory, selectorsFactory } from '../factory/reducers';

export const NAME = 'printers';

const { printersReducer } = reducersFactory({ name: NAME, baseAction: PRINTERS_FETCH });
export default printersReducer;

export const { getPrinters, getLastUpdated, isFetching } = selectorsFactory({
    name: NAME,
    entityMapper: compose(sortBy('ordering'), map(Device)),
});
